<div class="p-3 pt-0 text-center dark:text-white-dark ltr:sm:text-left rtl:sm:text-right">
    © {{ currYear }}. Loan Management System All rights reserved.
</div>
